import { useCallback, useContext } from 'react'
import { Rate } from 'src/subscribe'
import { Context } from 'src/Subscribe_'

const SubscriptionRate = ({ rate }: { rate: Rate }) => {
  const { dispatch } = useContext(Context)

  const handleClick = useCallback(() => {
    if (!rate.nid) {
      throw new Error("Rate doesn't have an nid (this should never happen)")
    }
    dispatch({
      payload: {
        values: {
          rate_nid: rate.nid,
        },
      },
      type: 'rate selected',
    })
  }, [rate.nid])

  return (
    <div className="views-row">
      <button className="rate-tile" onClick={handleClick} type="button">
        {rate.pricing_note && <div className="name">{rate.name}*</div>}
        {!rate.pricing_note && <div className="name">{rate.name}</div>}
        <div className="price-pricing-note">
          <div className="price">
            {rate.price_in_dollars} / <i>year</i>
          </div>
          {rate.pricing_note && (
            <div className="pricing-note">*{rate.pricing_note}</div>
          )}
        </div>
        <div className="description">
          <div dangerouslySetInnerHTML={{ __html: rate.description }} />
        </div>
        <div className="hole-punch" />
      </button>
    </div>
  )
}

export default SubscriptionRate
